import { g as o } from "./global.js";
var r = o.Promise;
export { r as p };